<template>
    <v-container fluid fill-height class="animated zoomIn">
        <v-row align="center" justify="center">
            <v-card width="600" class="pa-12" style="z-index: 999; border: 1px solid #ddd; border-radius: 5px;">
                <v-card-title >
                    <!-- <v-row align="center" justify="center">
                        <img src="../../../dist/assets/img/public/logo-normal.svg">
                    </v-row> -->
                   <v-avatar>
                        <img src="../../../public/logo-normal.png" alt="avatar">
                    </v-avatar>
                    &nbsp; &nbsp;
                    <h3 style="color: #006b93">Artilux Web portal</h3>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="username" label="Account:" outlined></v-text-field>
                    <v-text-field v-model="password" type="password" label="Password：" outlined></v-text-field>
                </v-card-text>
            
                <v-card-actions>
                    <a href="javascript: void(0)" class="a-aim-btn" style="width: 100%">
                        <span class="a-aim-btn__deco -top"></span>
                        <span class="a-aim-btn__deco -bottom"></span>
                        <span class="a-aim-btn__main" @click="login()">
                        <span class="a-aim-btn__main-text">Login</span>
                        </span>
                    </a>
                </v-card-actions>
                </v-card>
                <v-dialog v-model="errorDialog" persistent width="500" style="z-index: 999;" scrollable>
                    <v-card>
                        <v-card-title class="headline grey lighten-2" primary-title>Hint
                            <v-spacer/>
                            <v-icon @click="errorDialog=false">mdi-close</v-icon></v-card-title>
                        <v-card-text class="mt-6">
                            <v-row justify="center" align="center">
                                <v-col>
                                    <p class="headline" style="white-space: pre-wrap; ">{{ usernameErrorMsg }}</p>
                                    <p class="headline" style="white-space: pre-wrap;">{{ passwordErrorMsg }}</p>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click="errorDialog=false">Got it</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
        </v-row>
        
    </v-container>
</template>

<script>
import axios from 'axios'
var host_url = process.env.VUE_APP_HOST_URL
export default {
    data(){
        return {
            username: "",
            password: "",
            
            errorDialog: false,
            usernameErrorMsg: '',
            passwordErrorMsg: '',
        }
    },
    methods: {
        login(){

            let check = false
            this.usernameErrorMsg= ''
            this.passwordErrorMsg= ''
            if(this.username == ""){ check=true; this.usernameErrorMsg = "Account can not be empty" }            
            if(this.password == ""){ check=true; this.passwordErrorMsg = "Password can not be empty" }
            if(check ==true){ this.errorDialog = true; }
            // else{
            //     this.$router.push('/home')
            // }
            
            axios.post(host_url+'account/token/', {
                username: this.username,
                password: this.password
            })
            .then(response => {
                this.$cookies.set('csrftoken', response.data.csrftoken)
                console.log(response.data.csrftoken)
                this.record_login()                
                this.$router.push('/home')
            })
            .catch(error => {
                // console.log(error);
            });
        },
        record_login(){
            axios.post(host_url+'account/record_login/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    localStorage.setItem('login_id', tmp.data)
                }
            })
            .catch((error) => {
                // console.log(error)
            })
        
        
        }
    }
}
</script>
